import { render, staticRenderFns } from "./GetOrders.vue?vue&type=template&id=e50e79c4&scoped=true"
import script from "./GetOrders.vue?vue&type=script&lang=js"
export * from "./GetOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50e79c4",
  null
  
)

export default component.exports